<template>
  <validation-observer ref="formAddCampaign" #default="{ invalid }">
    <b-form @submit.prevent="formSubmitted">
      <div class="d-flex justify-content-center mb-1" v-if="mainLoading">
        <b-spinner
          variant="success"
          label="Spinning"
          block
          style="width: 3rem; height: 3rem"
        ></b-spinner>
      </div>
      <b-row v-if="!mainLoading">
        <b-col md="6">
          <b-form-group label="Campaign Name" label-for="campaign_name">
            <validation-provider
              rules="required"
              #default="{ errors }"
              name="campaign name"
              vid="Campaign Name"
            >
              <b-form-select
                v-model="campaignName"
                :options="campaignOptions"
                :state="errors.length > 0 ? false : null"
              />
              <small class="text-danger">{{ errors[0] }}</small>
            </validation-provider>
          </b-form-group>
        </b-col>
        <b-col md="6">
          <b-form-group label="Start Date" label-for="start_date">
            <validation-provider
              rules="required"
              #default="{ errors }"
              name="start date"
              vid="Start Date"
            >
              <b-form-datepicker
                v-model="startDate"
                id="start_date"
                placeholder="Choose a date"
                local="en"
                :state="errors.length > 0 ? false : null"
                :initial-date="new Date()"
              />
              <small class="text-danger">{{ errors[0] }}</small>
            </validation-provider>
          </b-form-group>
        </b-col>
        <b-col md="6">
          <b-form-group label="End Date" label-for="end_date">
            <validation-provider
              rules="required"
              #default="{ errors }"
              name="end date"
              vid="End Date"
            >
              <b-form-datepicker
                v-model="endDate"
                id="end_date"
                placeholder="Choose a date"
                local="en"
                :state="errors.length > 0 ? false : null"
                :initial-date="startDate"
                :min="startDate"
              />
              <small class="text-danger">{{ errors[0] }}</small>
            </validation-provider>
          </b-form-group>
        </b-col>
        <b-col md="6">
          <b-form-group label="Email Template" label-for="email_template">
            <validation-provider
              rules="required"
              #default="{ errors }"
              name="email template"
              vid="Email Template"
            >
              <b-form-select
                v-model="selectedTemplateId"
                :options="emailtemplatelist"
                @change="selectTemplate"
                :state="errors.length > 0 ? false : null"
              />
              <small class="text-danger">{{ errors[0] }}</small>
            </validation-provider>
          </b-form-group>
        </b-col>
        <b-col md="6">
          <b-form-group label="SMTP Setting" label-for="email_smtp">
            <validation-provider
              rules="required"
              #default="{ errors }"
              name="SMPT setting"
              vid="SMPT Setting"
            >
              <b-form-select
                v-model="selectedProvider"
                :state="errors.length > 0 ? false : null"
                :options="smtp"
              />

              <small class="text-danger">{{ errors[0] }}</small>
            </validation-provider>
          </b-form-group>
        </b-col>

        <b-col md="6">
          <b-form-group label="Segment" label-for="segment">
            <validation-provider
              rules="required"
              #default="{ errors }"
              name="segment"
              vid="Segment"
            >
              <v-select
                v-model="selectedSegments"
                :options="segmentOptions"
                label="itemTitle"
                multiple
                :clearable="false"
                class="item-selector-title"
                placeholder="Select Item"
                :state="errors.length > 0 ? false : null"
              />
              <small class="text-danger">{{ errors[0] }}</small>
            </validation-provider>
          </b-form-group>
        </b-col>
        <b-col md="12">
          <b-form-group label="Subject" label-for="subject">
            <validation-provider
              rules="required"
              #default="{ errors }"
              name="subject"
              vid="Subject"
            >
              <b-form-input
                v-model="selectedTemplate.subject"
                placeholder="Subject"
                name="subject"
                :state="errors.length > 0 ? false : null"
              />
              <small class="text-danger">{{ errors[0] }}</small>
            </validation-provider>
          </b-form-group>
        </b-col>
        <b-col md="12">
          <b-form-group label="Email Content" label-for="email_content">
            <validation-provider
              rules="required"
              #default="{ errors }"
              name="email content"
              vid="Email Content"
            >
              <quill-editor
                v-model="selectedTemplate.body"
                :state="errors.length > 0 ? false : null"
              />
              <small class="text-danger">{{ errors[0] }}</small>
            </validation-provider>
          </b-form-group>
        </b-col>

        <b-col md="12">
          <div class="demo-inline-spacing">
            <b-form-radio v-model="SelectedRadio" name="radio1" value="D">
              Save as Draft
            </b-form-radio>
            <b-form-radio v-model="SelectedRadio" name="radio1" value="A">
              Send Now
            </b-form-radio>
            <b-form-radio v-model="SelectedRadio" name="radio1" value="B">
              Schedule Sending
            </b-form-radio>
          </div>
        </b-col>

        <!-- date and time -->
        <b-col md="12" class="mt-2" v-if="SelectedRadio === 'B'">
          <b-form-group>
            <validation-provider
              rules="required"
              #default="{ errors }"
              name="date and time"
              vid="dateNtim"
            >
              <h5>Date & Time</h5>
              <b-form-datepicker
                v-model="dateNtim"
                id="form-control"
                placeholder="Choose a date"
                local="en"
                :initial-date="new Date()"
                :min="today"
                :state="errors.length > 0 ? false : null"
              />
              <small class="text-danger">{{ errors[0] }}</small>
            </validation-provider>
          </b-form-group>
        </b-col>

        <b-col md="12">
          <div class="demo-inline-spacing">
            <b-button
              v-if="showSaveDraft"
              @click="saveDraft"
              v-ripple.400="'rgba(255, 255, 255, 0.15)'"
              variant="warning"
            >
              Save as Draft
            </b-button>
            <b-button
              v-if="showSaveScheduled"
              @click="saveScheduled"
              v-ripple.400="'rgba(255, 255, 255, 0.15)'"
              variant="info"
            >
              Schedule
            </b-button>
            <b-button
              v-if="showSendNow"
              @click="sendNow"
              v-ripple.400="'rgba(255, 255, 255, 0.15)'"
              variant="success"
            >
              Send Now
            </b-button>
          </div>
        </b-col>
      </b-row>
    </b-form>
  </validation-observer>
</template>

<script>
import {
  BRow,
  BCol,
  BForm,
  BFormInput,
  BFormTextarea,
  BFormSelect,
  BFormDatepicker,
  BFormGroup,
  BButton,
  BSpinner,
  BFormFile,
  BFormRadio,
} from "bootstrap-vue";
import { mapActions, mapGetters } from "vuex";
import vSelect from "vue-select";
import { ValidationProvider, ValidationObserver } from "vee-validate";
import flatPickr from "vue-flatpickr-component";
import { required, email } from "@validations";
import {
  getProviderName,
  createProvider,
  deleteProvider,
  getProviders,
  testsmtp,
  updateProvider,
} from "@/store/smtp/services";

import { quillEditor } from "vue-quill-editor";
import campaign from "@/store/campaign";

export default {
  name: "AddCampaign",
  components: {
    BRow,
    BCol,
    BForm,
    BFormInput,
    BFormTextarea,
    BFormSelect,
    BFormDatepicker,
    BFormGroup,
    BButton,
    BSpinner,
    ValidationProvider,
    ValidationObserver,
    BFormFile,
    BFormRadio,
    vSelect,
    quillEditor,
    flatPickr,
  },
  data() {
    return {
      mainLoading: false,
      emailtemplatelist: [],
      selectedProvider: null,
      selectedTemplateId: null,
      selectedTemplate: [],
      Selected: "A",
      smtp: [],
      Selected1: "c",
      SelectedRadio: "D", // Default to "Save as Draft"
      dateNtim: null,
      selected: [{ title: "Segment 1" }, { title: "Segment 2" }],
      content: "",
      campaignName: "",
      startDate: null,
      endDate: null,
      subject: "",
      file: null,
      selectedSegments: [],
      segmentOptions: [],
      required,
      campaignOptions:[]
    };
  },

  computed: {
    ...mapGetters("emailtemplate", {
      emailtemplate: "emailtemplate",
      loading: "loading",
    }),
    ...mapGetters("segmentModule", {
      segments: "segments",
      loading: "loading",
    }),
    ...mapGetters("emailcampaign", {
      emailcampaign: "emailcampaign",
      loading: "loading",
    }),
    ...mapGetters("marketingModule", {
      campaigns: "campaigns",
      loading: "loading",
    }),
    showSaveDraft() {
      return this.SelectedRadio === "D";
    },
    showSaveScheduled() {
      return this.SelectedRadio === "B";
    },
    showSendNow() {
      return this.SelectedRadio === "A";
    },
    today() {
      const today = new Date();
      const year = today.getFullYear();
      const month = String(today.getMonth() + 1).padStart(2, "0");
      const day = String(today.getDate()).padStart(2, "0");
      return `${year}-${month}-${day}`;
    },


  },
  methods: {
    ...mapActions("segmentModule", ["getSegmentsAction"]),
    ...mapActions("emailtemplate", ["getEmailTemplateListAction"]),
    ...mapActions("emailcampaign", ["addEmailCampaignAction"]),
    ...mapActions("marketingModule", ["getCampaignsListAction"]),
    selectTemplate() {
      this.selectedTemplate = this.emailtemplate.find(
        (template) => template.templateId === this.selectedTemplateId
      );
    },

    errordateNtime() {
      this.$swal({
        title: "Error!",
        text: " Please select a date!",
        icon: "error",
        customClass: {
          confirmButton: "btn btn-primary",
        },
        buttonsStyling: false,
      });
    },

    async formSubmitted(status) {
      // Validate the form if status is not 'DRAFT'
      if (status !== "DRAFT") {
        const isValid = await this.$refs.formAddCampaign.validate();
        if (!isValid) {
          // Handle invalid form
          return;
        }
      }

      let loader = this.$swal({
        title: "Processing...",
        text: "Please wait while the Campaign is being added",
        onOpen: () => {
          this.$swal.showLoading();
        },
        allowOutsideClick: () => !this.$swal.isLoading(),
        buttonsStyling: false,
        showConfirmButton: false,
      });

      const cname = this.campaigns.find((s) => s.id === this.campaignName);
      const namesss = cname.name;

      const payload = {
        name: namesss,
        startDate: this.startDate,
        endDate: this.endDate,
        description: this.selectedTemplate.subject,
        subject: this.selectedTemplate.subject,
        status: status,
        templateId: this.selectedTemplateId,
        segmentId: this.selectedSegments.map((segment) => segment.value),
        campaignDrafts: [
          {
            content: this.selectedTemplate.body,
            scheduledPublishedDate:
              status === "SCHEDULED" ? this.dateNtim : null,
            segmentId: this.selectedSegments.map((segment) => segment.value),
          },
        ],
        smtpSettingId: this.selectedProvider,
      };

      console.log("payloaddddddddddddd", payload);

      await this.addEmailCampaignAction(payload)
        .then((response) => {
          loader.close();
          if (status === "SCHEDULED") {
            this.success(
              `Email Campaign successfully scheduled for ${this.dateNtim}!`
            );
          } else {
            this.success("Email sent to all users of chosen segment");
          }

          this.$router.push({ name: "email-list" });
        })
        .catch((ex) => {
          loader.close();
          this.error(ex.response.data);
        });
    },

    saveDraft() {
      this.formSubmitted("DRAFT");
    },
    success(message) {
      this.$swal({
        title: "Email Sent",
        text: message,
        icon: "success",
        customClass: {
          confirmButton: "btn btn-primary",
        },
        buttonsStyling: false,
      });
    },
    error(data) {
      let msg = null;
      if (data) msg = this.getErrorString(data);
      this.$swal({
        title: "Error!",
        html: msg ?? " Failed!",
        icon: "error",
        customClass: {
          confirmButton: "btn btn-primary",
        },
        buttonsStyling: false,
      });
    },
    getErrorString(data) {
      let msg = null;
      if (data.errors) {
        let errors = data.errors;
        msg = "<div>";
        msg += "<p>Cannot post your request due to the following errors:</p>";
        for (var prop in errors) {
          if (
            Object.prototype.hasOwnProperty.call(errors, prop) &&
            prop !== "request"
          ) {
            msg += "<p>";
            msg += prop.replace("$.", "");
            msg += ": ";
            msg += errors[prop].toString().replace("$.", "");
            msg += "</p>";
          }
        }
        msg += "</div>";
      } else if (data.message) {
        msg = "<div>";
        msg += "<p>Cannot post your request due to the following errors:</p>";
        msg += data.message;
        msg += "</div>";
      }
      return msg;
    },

    saveScheduled() {
      if (this.dateNtim === null) {
        this.errordateNtime();
        return;
      }

      if (this.SelectedRadio === "B" && this.dateNtim) {
        this.formSubmitted("SCHEDULED");
      } else {
        this.formSubmitted("DRAFT");
      }
    },

    sendNow() {
      if (this.SelectedRadio === "A") {
        this.formSubmitted("COMPLETED");
      }
    },

    async getSMPT() {
      try {
        const response = await getProviders();
        this.smtp = response.data.result.map((smtp) => ({
          value: smtp.id,
          text: `${smtp.provider}`,
        }));
      } catch (error) {
        console.log(error);
      }
    },
  },

  async mounted() {
    this.mainLoading = true;
    try {
      await this.getEmailTemplateListAction().then(() => {
        this.emailtemplatelist = this.emailtemplate.map((template) => ({
          value: template.templateId,
          text: `${template.name}`,
        }));
      });

      await this.getSMPT();
      await this.getCampaignsListAction().then(()=>{
        const filteredCampaigns = this.campaigns.filter(campaign => campaign.status === 'COMPLETED');
        this.campaignOptions = filteredCampaigns.map((campaign)=>({
          value:campaign.id,
          text: `${campaign.name}`,
        }));
      
      });
      await this.getSegmentsAction().then(() => {
        this.segmentOptions = this.segments.map((segment) => ({
          value: segment.segmentId,
          itemTitle: `${segment.name}`,
        }));
      });
    } catch (error) {
      console.log(error);
    } finally {
      this.mainLoading = false;
    }
  },
  watch: {
    startDate(newDate) {
      if (
        newDate &&
        this.endDate &&
        new Date(this.endDate) < new Date(newDate)
      ) {
        this.endDate = null; // Clear endDate if it is earlier than startDate
      }
    },
  },
};
</script>

<style lang="scss">
@import "@core/scss/vue/libs/vue-select.scss";
@import "@core/scss/vue/libs/vue-flatpicker.scss";
@import "@core/scss/vue/libs/quill.scss";
</style>
